// extracted by mini-css-extract-plugin
export default {"container":"ProfileWithImage_container__nofGg","image":"ProfileWithImage_image__MzB8C","content":"ProfileWithImage_content__GT7jV","name":"ProfileWithImage_name__m1YwX"};